import { useGtm } from "@gtm-support/vue-gtm";

export const trackConsentUpdated = (): void => {
  const event = {
    event: "consent_updated",
    action: "change",
    label: "Consent updated",
  };

  useGtm()?.trackEvent(event);
};
